import type { Block } from "@/lib/marketing/riddor-checker/checker";

/**
 * One block of the RIDDOR checker's outcome: a heading and its lines, each
 * line linked to the regulation or HSE page it comes from. Shared by the
 * interactive outcome and the page's "how the checker decides" section, so
 * both always print the same words.
 */
export function RiddorBlock({ block, headingLevel = 3 }: { block: Block; headingLevel?: 3 | 4 }) {
  const Heading = headingLevel === 3 ? "h3" : "h4";
  return (
    <div data-testid={`riddor-block-${block.id}`}>
      <Heading className="text-base font-bold text-gray-900">{block.heading}</Heading>
      <ul className="mt-2 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-gray-700">
        {block.lines.map((line) => (
          <li key={line.text}>
            {line.text}
            {line.cite && line.url ? (
              <>
                {" "}
                <a
                  href={line.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-brand-700 underline hover:text-accent-dark"
                >
                  ({line.cite})
                </a>
              </>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
